var _a;
import { createSlice } from '@reduxjs/toolkit';
var initialState = {
    currentPage: '/',
    isSidebarOpen: false,
    calendarEvent: [],
    deductions: []
};
var siteSlice = createSlice({
    name: 'site',
    initialState: initialState,
    reducers: {
        navigateTo: function (state, action) {
            state.currentPage = action.payload;
        },
        toggleSidebar: function (state) {
            state.isSidebarOpen = !state.isSidebarOpen;
        },
        openSidebar: function (state) {
            state.isSidebarOpen = true;
        },
        closeSidebar: function (state) {
            state.isSidebarOpen = false;
        },
        setGlobalCalendarEvents: function (state, action) {
            state.calendarEvent = action.payload;
        },
        setDeductions: function (state, action) {
            state.deductions = action.payload;
        }
    },
});
export var navigateTo = (_a = siteSlice.actions, _a.navigateTo), toggleSidebar = _a.toggleSidebar, openSidebar = _a.openSidebar, closeSidebar = _a.closeSidebar, setGlobalCalendarEvents = _a.setGlobalCalendarEvents, setDeductions = _a.setDeductions;
export default siteSlice.reducer;
